import { Field, flattenEmbeddedReducer } from '@/types/fields';

export const cleanUp = <T>(object: T): T | Record<string, unknown> => {
  if (object === undefined || object === null) {
    return object;
  } else if (typeof object !== 'object' || Array.isArray(object)) {
    if (Array.isArray(object)) {
      return object.filter((item: unknown): boolean => item !== null) as T;
    } else {
      return object;
    }
  } else {
    const entries = Object.entries(object);

    return entries.reduce(
      (
        result: Record<string, unknown>,
        [key, value]: [string, unknown],
      ): Record<string, unknown> => {
        return { ...result, [key]: cleanUp(value) };
      },
      {},
    );
  }
};

export const formLikeElementToObject = (
  container: HTMLFormElement | HTMLFieldSetElement,
  fields: readonly Field<any>[],
): Record<string, unknown> => {
  const elements = container.elements;
  const object: Record<string, unknown> = {};

  for (const field of fields.reduce(flattenEmbeddedReducer, [])) {
    const element = elements.namedItem(String(field.name));

    if (element === null) {
      // TODO: ensure that it probably just can be ignored, it seems that way
      console.debug(`element is null ${String(field.name)}`);
    } else if (element instanceof HTMLInputElement) {
      object[field.name] = parseValue(element.value);
    } else if (element instanceof HTMLSelectElement) {
      object[field.name] = parseValue(element.value);
    } else if (element instanceof HTMLTextAreaElement) {
      object[field.name] = parseValue(element.value);
    } else if (element instanceof RadioNodeList) {
      if (element.length === 0) {
        object[field.name] = null;
      } else {
        object[field.name] = Array.from(element)
          .filter((item: Node): item is HTMLInputElement => item instanceof HTMLInputElement)
          .filter((item: HTMLInputElement): boolean => item.checked)
          .map((item: HTMLInputElement): unknown => {
            return item.value;
          });
      }
    } else {
      console.debug('unexpected element type', element);
    }
  }

  return cleanUp(object);
};

const parseValue = (value: string): unknown => {
  if (value === '') {
    // The backend service accepts null as empty value,
    // but in the UI it is represented by an empty string
    return null;
  }

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};
